import { render } from "./AnnouncementReportRender.vue?vue&type=template&id=6f4318e3"
import script from "./AnnouncementReportRender.vue?vue&type=script&lang=js"
export * from "./AnnouncementReportRender.vue?vue&type=script&lang=js"
script.render = render

export default script